import { normalize, size } from 'polished';
import { createGlobalStyle } from 'styled-components';
import { typeStyle } from './typeStyle';
import { FontFamily } from './variables';

export const GlobalStyle = createGlobalStyle`
  ${normalize()}

  html {
    box-sizing: border-box;
    font-family: ${FontFamily.Arial};
    color: ${({ theme }) => theme.color.black};
    -webkit-text-size-adjust: 100%;
    overscroll-behavior-x: contain;
  }

  body {
    ${typeStyle.normal};
    margin: 0;
  }

  html, body {
    ${size('100%')};
  }

  *,
  *:before,
  *:after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: inherit;
  }

  a {
    color: currentColor;
    text-decoration: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-weight: normal;
    margin: 0;
  }

  ul,
  ol, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  button,
  input {
    padding: 0;
    outline: 0;
    border: none;
    background: none;
  }

  #root {
    height: 100%;
  }

  .simplebar-scrollbar:before {
    width: 0.3125rem;
    background: ${({ theme }) => theme.color.lighterGrey};
    border-radius: 0;
    left: 0.3125rem;
    right: 0;
    border-radius: ${({ theme }) => theme.defaultCssProps.borderRadius.normal};
  }

  .simplebar-scrollbar.simplebar-visible:before {
    opacity: 1;
  }

  .mapboxgl-ctrl-bottom-right{
    z-index: 5;
  }

  .mapboxgl-ctrl-bottom-left{
    z-index: 2;
  }

`;
